import { useCallback, useMemo } from 'react';
import TagManagerLib from 'react-gtm-module';

import { getEnvVars } from '@order/utils';

import { tagManagerLogger as logger } from './TagManager.logger';
import type { TagManager } from './TagManager.types';

const DATA_LAYER_NAME = 'dataLayer';

export const useTagManager = (): TagManager => {
  const initialize: TagManager['initialize'] = useCallback(() => {
    const { GTM_AUTH, GTM_CONTAINER_ID, GTM_ENVIRONMENT } = getEnvVars();

    logger.info('initialize()');

    TagManagerLib.initialize({
      auth: GTM_AUTH,
      gtmId: GTM_CONTAINER_ID,
      preview: GTM_ENVIRONMENT,
      dataLayerName: DATA_LAYER_NAME,
    });
  }, []);

  const dataLayer: TagManager['dataLayer'] = useCallback((payload) => {
    logger.info(`dataLayer(${JSON.stringify(payload)})`);

    TagManagerLib.dataLayer({
      dataLayer: payload,
      dataLayerName: DATA_LAYER_NAME,
    });
  }, []);

  return useMemo(() => ({ initialize, dataLayer }), [dataLayer, initialize]);
};
